import { i18n } from './i18n';

const validation = {
  // 驗證單一value
  isRequired: function(value = '') {
    let msg = '';
    if (value === '' || value === null || typeof value === 'undefined') {
      msg = i18n('required');
    }
    return msg;
  },
  isChinese: function(value, isRequired = true) {
    let msg = '';
    const regex = /^[\u4E00-\u9FA5]{2,13}$/;
    if (typeof value === 'string' && value === '' && isRequired) {
      msg = i18n('required');
    } else if (!!value && !regex.test(value)) {
      msg = i18n('invalid_format');
    }
    return msg;
  },
  name: function(value, isRequired = true) {
    let msg = '';
    const regex = /^[A-Za-z]+$/; //只允許大小寫英文
    if (typeof value === 'string' && value === '' && isRequired) {
      msg = i18n('required');
    } else if (!!value && !regex.test(value)) {
      msg = i18n('invalid_format');
    }
    return msg;
  },
  email: function(value, isRequired = true) {
    let msg = '';
    if (typeof value === 'string' && value === '' && isRequired) {
      msg = i18n('required');
    } else if (4) {
      const regexEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (!(value.length <= 50) || !regexEmail.test(value)) {
        msg = i18n('error_email');
      }
    }
    return msg;
  },
  phone: function(value, isRequired = true) {
    let msg = '';
    const regex = /^[0-9]+$/;
    if (typeof value === 'string' && value === '' && isRequired) {
      msg = i18n('required');
    } else if (!!value && !regex.test(value)) {
      msg = i18n('invalid_format');
    }
    return msg;
  },
  amount: function(value) {
    let msg = '';
    const regex = /^[0-9]+$/;
    if (!!value && !regex.test(value)) {
      msg = i18n('invalid_format');
    }
    return msg;
  },
  password: function(value, isRequired = true) {
    let msg = '';
    const regex = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[()`!@#$%?/-])(?!.*[^a-zA-Z0-9()`!@#$%?/-])(.{8,16})$/;
    if (typeof value === 'string' && value === '' && isRequired) {
      msg = i18n('required');
    } else if (!!value && !regex.test(value)) {
      msg = i18n('error_password');
    }
    return msg;
  },
  
  // 驗證整包data
  validateLoginInfo: function (data) {
    let errors = {};
    Object.keys(data).forEach((key) => {
      const value = data[key];
      let msg = '';
      switch (key) {
        default:
          msg = validation.isRequired(value);
          break;
      }
      if (msg) {
        errors[key] = msg;
      }
    });
    return errors;
  },
  validateForgot: function (data) {
    let errors = {};
    Object.keys(data).forEach((key) => {
      const value = data[key];
      let msg = '';
      switch (key) {
        case 'token':
          break;
        default:
          msg = validation.password(value);
          break;
      }
      if (msg) {
        errors[key] = msg;
      }
    });
    if (!errors && data.newMima !== data.confirmMima) { 
      errors.confirmMima = i18n('error_confirm_password')
    }
    return errors;
  },
  validateAgentInfo: function (data) {
    let errors = {};
    Object.keys(data).forEach((key) => {
      const value = data[key];
      let msg = '';
      switch (key) {
        case 'firstName':
        case 'lastName':
          msg = validation.name(value);
          break;
        case 'mobilePhone':
        case 'workPhone':
          if (value) {
            let numberMsg = validation.phone(value.number),
              dialCodeMsg = validation.isRequired(value.dialCode);

            if (numberMsg || dialCodeMsg) {
              errors[key] = {};
              if (numberMsg) errors[key].number = numberMsg;
              if (dialCodeMsg) errors[key].dialCode = dialCodeMsg;
            }
          }
          break;
        case 'email':
        case 'confirmEmail':
          msg = validation.email(value);
          break;
        case 'password':
        case 'confirmPassword':
          msg = validation.password(value);
          break;
        // 不需檢核的欄位
        case 'address2':
        case 'postalCode':
          break;
        // 預設檢核(必填)
        default:
          msg = validation.isRequired(value);
          break;
      }
      if (msg) {
        errors[key] = msg;
      }
    });
    return errors;
  }
};

export default validation;
